import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import reveal from './directives/reveal'
import '@/assets/main.css'

const app = createApp(App)

app.directive('reveal', reveal)
app.use(store)
app.use(router)

app.mount('#app')
